module.exports = __webpack_public_path__ + "static/media/mailing-placeholder.ed64987d.svg";